// Third party libraries
import LazyLoad from 'vanilla-lazyload';
import $ from 'jquery';
import 'bootstrap';
import 'parsleyjs';

// Utils
import createModal from '../../_common/scripts/modals.js';
import classLoader from './utils/class-loader';

// Forms
import AustralianTelInput from './components/form/australian-tel';
import DatePickerInput from './components/form/date-picker';
import InterTelInput from './components/form/inter-tel';
import FullNameInput from './components/form/full-name';
import MinDate from './components/form/min-date';

// Components
import SearchResults from '../../_common/scripts/search-results';
import SearchFilters from '../../_common/scripts/search-filters';
import Pagination from '../../_common/scripts/pagination';
import DynamicFixed from './components/dynamic_fixed';
import ShortlistNew from './components/shortlist-new';
import FilterPopups from './components/filter-popup';
import Phone from '../../_common/scripts/phone.js';
import Legacy from '../../_common/scripts/legacy';
import Click from '../../_common/scripts/click';
import Shortlist from './components/shortlist';
import SearchBar from './components/search-bar';
import SmartNav from './components/smart-nav';
import ScrollTo from './components/scroll-to';
import Enquiry from './components/enquiry';
import Banners from './components/banners';
import Sliders from './components/sliders';
import NavBar from './components/nav-bar';
import Video from './components/videos';

// Pages
import Categories from '../../categories/scripts/main';
import Homepage from '../../homepage-new/scripts/main';
import Portal from '../../portal-new/scripts/main';
import Minisite from '../../minisite/scripts/main';
import Articles from '../../articles/scripts/main';
import Signup from '../../signup/scripts/main';
import Login from '../../login/scripts/main';

$(() => {
  [
    { _class: NavBar },
    { _class: SearchBar },
    { _class: Shortlist },
    { _class: ShortlistNew },
    { _class: AustralianTelInput },
    { _class: DatePickerInput },
    { _class: InterTelInput },
    { _class: FullNameInput },
    { _class: MinDate },
    { _class: Pagination },
    { _class: Phone },
    { _class: SearchResults },
    { _class: SearchFilters },
    { _class: Click },
    { _class: Video },
    { _class: Legacy },
    { _class: Enquiry },
    { _class: Banners },
    { _class: DynamicFixed },
    { _class: FilterPopups },
    { _class: SmartNav },
    { _class: ScrollTo },
    { _class: Sliders },
    //
    { _class: Categories },
    { _class: Homepage },
    { _class: Minisite },
    { _class: Articles },
    { _class: Signup },
    { _class: Portal },
    { _class: Login }
  ]
    .forEach(classLoader);

  // Lazy loading
  const lazyLoad = new LazyLoad({ elements_selector: '.lazy' });
  if (lazyLoad) lazyLoad.update();

  // Global callbacks
  const handleDropdownHover = enter => function () {
    $(this)
      .find('.dropdown-menu')
      .stop(true, true)
      .delay(200)
      // eslint-disable-next-line no-unexpected-multiline
      [`fade${enter ? 'In' : 'Out'}`](250);
  };

  // Global events
  $('body')
    // Enabling modal triggers
    .on('click', '.modal-trigger', function (e) {
      // If we are on phone we don't do Modal and we let it open in a new window
      if (!window.isPhone) {
        e.preventDefault();
        $('.modal')
          .on('show.bs.modal', createModal($(this), $))
          .modal('show');
      }
    })
    // Enabling hoverable dropdowns
    .on('mouseleave', '.dropdown.hover', handleDropdownHover(false))
    .on('mouseenter', '.dropdown.hover', handleDropdownHover(true));

  // todo: move to the portal entry
  if (/^portal\//.test(window.route)) {
    // Shown if such modal exists
    $('#invoice-alert').modal('show');
  }
});



// WEBPACK FOOTER //
// ./vively/scripts/main.js